import Vue from 'vue';
import Router from 'vue-router';

// Routes
Vue.use(Router);

export const routes = [
  {
    path: '/',
    redirect: '/system'
  },
  {
    path: '/system',
    name: 'system',
    component: () => import('@/pages/System.vue')
  },
  {
    path: '/project',
    name: 'project',
    component: () => import('@/pages/Project.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('@/pages/Product.vue')
  },
  {
    path: '/attribute',
    name: 'attribute',
    component: () => import('@/pages/Attribute.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/pages/Admin.vue')
  },
  {
    path: '/blank',
    name: 'blank',
    component: () => import('@/pages/BlankPage.vue')
  },
  {
    path: '*',
    name: 'error',
    component: () => import('@/pages/error/NotFoundPage.vue'),
    meta: {
      layout: 'error'
    }
  }
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes
});

/**
 * Before each route update
 */
router.beforeEach((to, from, next) => {
  return next();
});

/**
 * After each route update
 */
router.afterEach(() => {});

export default router;
